import React, { createContext, PropsWithChildren, useMemo } from 'react';
import { useDelayed } from '../../hooks/useDelayed';

type RefreshViewContext = {
  refreshView: (refreshProps?: any) => void;
  delayedRefreshView: (refreshProps?: any) => void;
};
type RefreshViewContextProps = Omit<RefreshViewContext, 'delayedRefreshView'>;
export const RefreshViewContext = createContext<RefreshViewContext | undefined>(undefined);

export function RefreshViewContextProvider({ refreshView, children }: PropsWithChildren<RefreshViewContextProps>) {
  const delayedRefreshView = useDelayed(refreshView);

  const refreshContextValue = useMemo(
    () => ({
      refreshView,
      delayedRefreshView,
    }),
    [refreshView, delayedRefreshView]
  );

  return <RefreshViewContext.Provider value={refreshContextValue}>{children}</RefreshViewContext.Provider>;
}
